import React, { Component } from "react";
import Slider from "react-slick";
import "./index.scss";
import styles from "./index.module.scss";

function SampleNextArrow(props) {
  const { onClick } = props;
  return (
    <div className={`${styles.arrow} ${styles.nextArrow}`} onClick={onClick}>
      <img src="/images/right_arrow.png" alt="" />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { onClick } = props;
  return (
    <div className={`${styles.arrow} ${styles.prevArrow}`} onClick={onClick}>
      <img src="/images/left_arrow.png" alt="" />
    </div>
  );
}

export default class SimpleSlider extends Component {
  render() {
    const responsive = [
      {
        breakpoint: 1450,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 1250,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 590,
        settings: {
          slidesToShow: 1
        }
      }
    ];
    const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      initialSlide: 0,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
      responsive
    };
    const { list, ambulance } = this.props;
    return (
      <div style={{ width: "100%" }}>
        <Slider {...settings}>
          {list.map(v => (
            <a key={v.id} href={v.buy_url} target="view_window">
              <div style={{ width: 308 }}>
                <div className={`${styles.slider_container} slider_container`}>
                  <img src={ambulance + v.photo} alt="" />
                  <div className={styles.text}>
                    <div className={styles.title}>{v.name}</div>
                    <div className={styles.desc}>{v.tips}</div>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </Slider>
      </div>
    );
  }
}
